"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = exports.SelectorInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const lodash_1 = require("lodash");
exports.SelectorInput = styled_components_1.default.input `
  padding: 5px;
  flex-grow: 1;
  border: 1px solid
    ${(p) => (p.disabled ? theme_1.theme.colors.grey(3) : theme_1.theme.colors.grey(3))};
  border-radius: 4px;
  height: 40px;
  ${theme_1.theme.fontSize(-1)};
  color: ${(p) => (p.disabled ? theme_1.theme.colors.grey(2) : theme_1.theme.colors.blackText)};
  background-color: ${(p) => p.disabled ? theme_1.theme.colors.grey(4) : theme_1.theme.colors.white};
`;
const TextInput = (props) => {
    const { disabled, value, onChange, disableDebounce, placeholder } = props;
    const [textContent, setTextContent] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        if (value !== textContent) {
            setTextContent(value);
        }
    }, [value]);
    const sendChange = (0, react_1.useCallback)((0, lodash_1.debounce)((value) => {
        if (onChange) {
            onChange(value);
        }
    }, 1000), []);
    const directSendChange = (value) => {
        if (onChange) {
            onChange(value);
        }
    };
    const onTextEdited = (0, react_1.useCallback)((text) => {
        setTextContent(text);
        if (disableDebounce) {
            directSendChange(text);
        }
        else {
            sendChange(text);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.SelectorInput, { value: textContent, type: "text", onChange: (e) => onTextEdited(e.target.value), disabled: disabled, placeholder: placeholder }));
};
exports.TextInput = TextInput;
